import { pageHead, unavailableHead, hasUnavailableMatch } from "@/lib/seoPolicy";
import { createFileRoute } from "@tanstack/react-router";
import FenceRestoration from "@/pages/FenceRestoration";

export const Route = createFileRoute("/_public/services/fence-restoration")({
  head: ({ matches }) => hasUnavailableMatch(matches) ? unavailableHead() : pageHead("Fence Restoration \u2014 Reuse Your Existing Posts | Modern Fence Install", "Reuse sound existing chain-link or metal fence posts and upgrade to professional non-electric containment mesh instead of paying for a full replacement.", "/services/fence-restoration", false),
  component: FenceRestoration,
});
